import React, { useState } from "react";
import { SectionHeader } from "./SectionHeader";

export const Method = ({ data, section }) => {
  const [open, setOpen] = useState(0);
  const s = section || {};
  if (!data) return null;
  return (
    <div id="method">
      <div className="container">
        <div className="row">
          <div className="col-md-8 col-md-offset-2">
            <SectionHeader heading={s.heading} subheading={s.subheading} />
          </div>
        </div>
        <div className="row">
          {data.map((d, i) => (
            <div key={i} className="col-md-3 col-sm-6 method-step">
              <div
                className={`method-card${open === i ? " method-card-open" : ""}`}
                onMouseEnter={() => setOpen(i)}
              >
                <div className="method-step-num">{d.step}</div>
                <h3>{d.title}</h3>
                <p>{d.text}</p>
                {open === i && <p className="method-detail"><strong>{d.detail}</strong></p>}
              </div>
            </div>
          ))}
        </div>
        {s.footer && (
          <div className="row text-center" style={{ marginTop: "20px" }}>
            <p className="method-footer"><em>{s.footer}</em></p>
          </div>
        )}
      </div>
    </div>
  );
};
